"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.newApi = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _url = require("../util/url.js");

var _date = require("../util/date.js");

var _time = require("../util/time.js");

var _templateObject, _templateObject2, _templateObject3;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var newApi = function newApi(_ref) {
  var amsResponse = _ref.amsResponse,
      config = _ref.config;

  var stationImageUrl = function stationImageUrl(station) {
    return "".concat(config.amsBaseUrl, "/v1.1/image/Station_").concat(station.id);
  };

  var stationMapUrl = function stationMapUrl(station) {
    return "".concat(config.amsBaseUrl, "/v1.1/image/Station_").concat(station.id, "_Karte");
  };

  var normalizeStation = function normalizeStation() {
    var station = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return _objectSpread(_objectSpread({}, station), {}, {
      openingInfos: station.openingInfos || [],
      imageUrl: stationImageUrl(station),
      mapUrl: stationMapUrl(station)
    });
  };

  return {
    getStations: function () {
      var _getStations = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(_ref2) {
        var contractTypes, data, stations;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                contractTypes = _ref2.contractTypes;
                _context.next = 3;
                return amsResponse.getData({
                  method: "GET",
                  path: "v1.1/stations",
                  query: {
                    contractTypes: contractTypes.join(",")
                  }
                });

              case 3:
                data = _context.sent;
                stations = data || [];
                return _context.abrupt("return", stations.map(normalizeStation));

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function getStations(_x) {
        return _getStations.apply(this, arguments);
      }

      return getStations;
    }(),
    getStation: function () {
      var _getStation = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(_ref3) {
        var stationId, station;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                stationId = _ref3.stationId;
                _context2.next = 3;
                return amsResponse.getData({
                  method: "GET",
                  path: (0, _url.urlPath)(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["v1.1/station/", ""])), stationId)
                });

              case 3:
                station = _context2.sent;
                return _context2.abrupt("return", normalizeStation(station));

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function getStation(_x2) {
        return _getStation.apply(this, arguments);
      }

      return getStation;
    }(),
    getStationOpeningTimes: function () {
      var _getStationOpeningTimes = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(_ref4) {
        var stationId, data, openingTimes;
        return _regenerator["default"].wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                stationId = _ref4.stationId;
                _context3.next = 3;
                return amsResponse.getData({
                  method: "GET",
                  path: (0, _url.urlPath)(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["v1.1/station/", "/openingTimes"])), stationId)
                });

              case 3:
                data = _context3.sent;
                openingTimes = data || [];
                return _context3.abrupt("return", openingTimes.map(function (openingTime) {
                  return _objectSpread(_objectSpread({}, openingTime), {}, {
                    fromDate: (0, _date.parseDate)(openingTime.openDate),
                    tillDate: (0, _date.parseDate)(openingTime.openDateTill),
                    fromTime: (0, _time.isoStringToTime)(openingTime.openfromTime),
                    tillTime: (0, _time.isoStringToTime)(openingTime.openTillTime)
                  });
                }));

              case 6:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function getStationOpeningTimes(_x3) {
        return _getStationOpeningTimes.apply(this, arguments);
      }

      return getStationOpeningTimes;
    }(),
    getStationBookingRules: function () {
      var _getStationBookingRules = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4(_ref5) {
        var stationId, _ref5$contractType, contractType, objectPositionId, exactMatchContractType, data, bookingRules;

        return _regenerator["default"].wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                stationId = _ref5.stationId, _ref5$contractType = _ref5.contractType, contractType = _ref5$contractType === void 0 ? "0" : _ref5$contractType;
                objectPositionId = 0; // We want to fetch bookingRules for all objectPositions

                exactMatchContractType = 1; // We want to fetch bookingRules only for the given contractType

                _context4.next = 5;
                return amsResponse.getData({
                  method: "GET",
                  path: (0, _url.urlPath)(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2["default"])(["v1.1/dispSurBookingRules/", "/", "/", "/", ""])), contractType, stationId, objectPositionId, exactMatchContractType)
                });

              case 5:
                data = _context4.sent;
                bookingRules = data || [];
                return _context4.abrupt("return", bookingRules.map(function (bookingRule) {
                  return _objectSpread(_objectSpread({}, bookingRule), {}, {
                    valueInMinutes: Number(bookingRule.value)
                  });
                }));

              case 8:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      function getStationBookingRules(_x4) {
        return _getStationBookingRules.apply(this, arguments);
      }

      return getStationBookingRules;
    }()
  };
};

exports.newApi = newApi;